import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Image, Typography, Breadcrumb, Grid } from 'antd';
import Pict1 from '../../assets/img/gallery-2022/Appreciation Session.JPG';
import Pict2 from '../../assets/img/gallery-2022/Best Oral Presenters of 1st WCHSS.JPG';
import Pict3 from '../../assets/img/gallery-2022/Brief Report by The Chief of 1st WCHSS.JPG';
import Pict4 from '../../assets/img/gallery-2022/On-site Registration.JPG';
import Pict5 from '../../assets/img/gallery-2022/Opening Traditional Dance.JPG';
import Pict6 from '../../assets/img/gallery-2022/Oral Presentation Room 1.JPG';
import Pict7 from '../../assets/img/gallery-2022/Oral Presentation Room 2.JPG';
import Pict8 from '../../assets/img/gallery-2022/Poster Exhibition.JPG';
import Pict9 from '../../assets/img/gallery-2022/QnA Session to The Speaker.JPG';
import Pict10 from '../../assets/img/gallery-2022/Singing national anthem.JPG';
import Pict11 from '../../assets/img/gallery-2022/Speech by Prof. Vidhya.JPG';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Gallery() {
  let { xs } = useBreakpoint()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  return (
    <React.Fragment>
      <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Gallery</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span={24}>
          {
            xs ?
              <Row gutter={[16,16]} justify="space-around" align="middle">
                {/* gallery 1 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict3}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle" style={{ paddingBottom: 16 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Brief Report by The Chief of 1st WCHSS</Text>
                </Col>
                {/* gallery 2 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict4}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle" style={{ paddingBottom: 16 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>On-site Registration</Text>
                </Col>
                {/* gallery 3 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict5}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle" style={{ paddingBottom: 16 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Opening Traditional Dance</Text>
                </Col>
                {/* gallery 5 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict10}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle" style={{ paddingBottom: 16 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Singing National Anthem</Text>
                </Col>
                {/* gallery 6 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict11}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle" style={{ paddingBottom: 16 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Speech by Prof. Vidhya</Text>
                </Col>
                {/* gallery 7 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict9}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle" style={{ paddingBottom: 16 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>QnA Session to The Speaker</Text>
                </Col>
                {/* gallery 8 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict2}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle" style={{ paddingBottom: 16 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Best Oral Presenters of 1st WCHSS</Text>
                </Col>
                {/* gallery 9 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict6}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle" style={{ paddingBottom: 16 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Oral Presentation Room 1</Text>
                </Col>
                {/* gallery 10 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict7}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle" style={{ paddingBottom: 16 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Oral Presentation Room 2</Text>
                </Col>
                {/* gallery 11 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict8}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle" style={{ paddingBottom: 16 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Poster Exhibition</Text>
                </Col>
                {/* gallery 12 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict1}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle" style={{ paddingBottom: 16 }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>Appreciation Session</Text>
                </Col>
              </Row>
            :
              <Row gutter={[32,32]} justify="space-around" align="middle">
                {/* gallery 1 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict3}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle">
                  <Text style={{ fontSize: 24, fontWeight: 'bold' }}>Brief Report by The Chief of 1st WCHSS</Text>
                </Col>
                {/* gallery 2 */}
                <Col xs={24} md={12} align="middle">
                  <Text style={{ fontSize: 24, fontWeight: 'bold' }}>On-site Registration</Text>
                </Col>
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict4}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                {/* gallery 3 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict5}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle">
                  <Text style={{ fontSize: 24, fontWeight: 'bold' }}>Opening Traditional Dance</Text>
                </Col>
                {/* gallery 5 */}
                <Col xs={24} md={12} align="middle">
                  <Text style={{ fontSize: 24, fontWeight: 'bold' }}>Singing National Anthem</Text>
                </Col>
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict10}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                {/* gallery 6 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict11}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle">
                  <Text style={{ fontSize: 24, fontWeight: 'bold' }}>Speech by Prof. Vidhya</Text>
                </Col>
                {/* gallery 7 */}
                <Col xs={24} md={12} align="middle">
                  <Text style={{ fontSize: 24, fontWeight: 'bold' }}>QnA Session to The Speaker</Text>
                </Col>
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict9}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                {/* gallery 8 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict2}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle">
                  <Text style={{ fontSize: 24, fontWeight: 'bold' }}>Best Oral Presenters of 1st WCHSS</Text>
                </Col>
                {/* gallery 9 */}
                <Col xs={24} md={12} align="middle">
                  <Text style={{ fontSize: 24, fontWeight: 'bold' }}>Oral Presentation Room 1</Text>
                </Col>
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict6}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                {/* gallery 10 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict7}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle">
                  <Text style={{ fontSize: 24, fontWeight: 'bold' }}>Oral Presentation Room 2</Text>
                </Col>
                {/* gallery 11 */}
                <Col xs={24} md={12} align="middle">
                  <Text style={{ fontSize: 24, fontWeight: 'bold' }}>Poster Exhibition</Text>
                </Col>
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict8}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                {/* gallery 12 */}
                <Col xs={24} md={12}>
                  <Image
                    width={'100%'}
                    height={350}
                    src={Pict1}
                    preview={false}
                    style={{ objectFit: 'cover' }}
                  />
                </Col>
                <Col xs={24} md={12} align="middle">
                  <Text style={{ fontSize: 24, fontWeight: 'bold' }}>Appreciation Session</Text>
                </Col>
              </Row>
          }
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Gallery